import { DealRequest } from '@/app/api/types';
import { getInternationalDealKind } from '@/app/helpers/international-deal';
import { checkIsDealWithoutRegistry } from '@/shared/single-deal/lib/check-deal-flags';
import { Actor } from '../types';

/** Порядок карточек подписантов */
const SIGNER_ORDER: Actor[] = ['buyer', 'seller', 'factor'];

/**
 * Стороны, которые должны подписать документы сделки.
 *
 * Реестр задолженности всегда подписывают три стороны, поэтому там, где он
 * есть (открытый и реверсивный факторинг), состав не зависит от тумблера
 * трёхстороннего договора. Без реестра остаётся только договор факторинга:
 * его подписывают фактор и поставщик, а у импортного — фактор и покупатель.
 */
export const getExpectedSignerActors = (row: DealRequest): Actor[] => {
  if (!checkIsDealWithoutRegistry(row)) return SIGNER_ORDER;

  return getInternationalDealKind(row) === 'import'
    ? ['buyer', 'factor']
    : ['seller', 'factor'];
};

export const getSignerActors = (
  row: DealRequest,
  actualActors: string[]
): Actor[] => {
  const expected = getExpectedSignerActors(row);
  return SIGNER_ORDER.filter(
    (actor) => expected.includes(actor) || actualActors.includes(actor)
  );
};
